(function ($) {
  const initializeBlock = function ($block) {
    function matchHeightFire() {
      $block
        .find(".imageBox .imageBox__body")
        .matchHeight({ property: "min-height" });
    }

    matchHeightFire();

    $(window).bind("resize orientationchange", function () {
      matchHeightFire();
    });

    setTimeout(function () {
      matchHeightFire();
    }, 1000);

    const $carousel = $block.find(".imageBoxes--slider");
    if($carousel.hasClass('slick-initialized'))
      $carousel.slick('unslick');
    $carousel.slick({
      prevArrow: $block.find(".imageBoxes-arrow--prev"),
      nextArrow: $block.find(".imageBoxes-arrow--next"),
      arrows: true,
      dots: false,
      mobileFirst: true,
      slidesToScroll: 1,
      swipe: true,
      adaptiveHeight: false,
      autoplay: true,
      autoplaySpeed: 7000,
    });
  };

  $(document).ready(function () {
    $(".block--image-boxes").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=image-boxes",
      initializeBlock
    );
  }
})(jQuery);
